import React, { useState, useRef, useEffect } from 'react';
import './StatusDropdown.css';

// options: [{ value, label, tone }] - tone controls the pill color (e.g. 'neutral', 'warning', 'success', 'danger')
const StatusDropdown = ({ value, options, placeholder = 'Select', onChange, disabled = false }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selected = options.find(o => o.value === value);
    const tone = selected ? selected.tone : 'neutral';

    const handleSelect = (option) => {
        setOpen(false);
        if (option.value !== value) {
            onChange(option.value);
        }
    };

    return (
        <div className={`status-dropdown ${disabled ? 'is-disabled' : ''}`} ref={rootRef}>
            <button
                type="button"
                className={`status-dropdown-trigger tone-${tone}`}
                onClick={() => !disabled && setOpen(prev => !prev)}
                disabled={disabled}
            >
                <span className="status-dropdown-value">
                    {selected ? selected.label : placeholder}
                </span>
                <i className={`fas fa-chevron-down status-dropdown-caret ${open ? 'is-open' : ''}`}></i>
            </button>

            {open && (
                <div className="status-dropdown-menu">
                    <button
                        type="button"
                        className={`status-dropdown-item ${!value ? 'is-active' : ''}`}
                        onClick={() => handleSelect({ value: '', label: placeholder, tone: 'neutral' })}
                    >
                        {placeholder}
                    </button>
                    {options.map(option => (
                        <button
                            type="button"
                            key={option.value}
                            className={`status-dropdown-item tone-${option.tone} ${value === option.value ? 'is-active' : ''}`}
                            onClick={() => handleSelect(option)}
                        >
                            <span className={`status-dot tone-${option.tone}`}></span>
                            {option.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default StatusDropdown;
